import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  Lookup,
} from "devextreme-react/data-grid";
import { FillFilters, FormatPhoneNumber, loadLookupFromDataSource } from '../../../../common/Utils'
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import '../../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];






const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "385A15CB-E7D2-46EB-B5D3-7D75293D2FD7";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const initialFormFields = {
        RECORD: '',
        STATUS: '',
        ITEMCODE: '',
        R_Customer: '',
        R_Warehouse: '',
        R_Profile: '',
        CLASSCODE: '',
        SUBCLASSCODE: ''
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const statuses = [{ id: 'A', text: 'Active' }, { id: 'I', text: 'Inactive' }];
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].ROWID;
        }
        else 
        {
            rowId.current = '';
        }

        setIsEditButtonDisabled(!isEditButtonDisabled);
    };

    const handelEditClick = () => {
        const buttonUrl = "/wm/codes/edit-item?id=" + rowId.current;
    history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource();
        const { IDTYPE, ...filteredFormFields } = formFields;
        const filters = FillFilters(filteredFormFields);
        datasource.filter(filters);
        setResultData(datasource);
    }
    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
    }
    useEffect(() => {
        if (formFields.RECORD === '' && formFields.STATUS === '' && formFields.ITEMCODE === '' && formFields.R_Customer === ''
            && formFields.R_Warehouse === '' && formFields.R_Profile === '' && formFields.CLASSCODE === '' && formFields.SUBCLASSCODE === ''
        )
            setResultData(loadDatasource);
    }, [formFields]);

    const handleFormLoad = useCallback(() => {
        loadLookupFromStaticData(formRefs, "STATUS", statuses);

    }, []);
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'text');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };

    const handleFieldChange = useCallback((name, value) => {
        // console.log(name, value);
    }, []);


    const loadDatasource = () => {
        let store = createStore({
            key: 'ROWID',
            loadParams: formFields,
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Item.GetItemsListingData}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    }
    const [resultData, setResultData] = useState(null);


    const handleValueChanged = (e) => {
        console.log(e)
    }

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For Item Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='1E58A628-DCE1-43E6-A46A-F6D1B4D51BFF'
                                layoutName='WMItemDataEntrySearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Selection mode="multiple" />
                            <Sorting visible={true} mode="multiple" />
                            <Paging defaultPageSize={10} />
                            <Pager
                                visible={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                            />
                            <FilterRow visible={true} />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            />
                            <FilterRow visible={true} />
                            <Column dataType="string" caption='WH' dataField='WHID' />
                            <Column dataType="string" caption='Item' dataField='ITEMCODE' />
                            <Column dataType="string" caption='Item Type' dataField='ITEMTYPE' >
                                <Lookup
                                    dataSource={[{ id: 'I', text: 'Item' }, { id: 'L', text: 'Item/Lot' }, { id: 'S', text: 'Item/Lot/Sublot' }, { id: 'U', text: 'Item/Lot/Sublot/Uni' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column dataType="string" caption='Description - 1' dataField='DESCRIPTION_1' />
                            <Column dataType="string" caption='Description - 2' dataField='DESCRIPTION_2' />
                            <Column dataType="string" caption='Class' dataField='CLASSCODE' />
                            <Column dataType="string" caption='Sub Class' dataField='SUBCLASSCODE' />
                            <Column dataType="string" caption='Status' dataField='STATUS' >
                                <Lookup
                                    dataSource={[{ id: 'A', text: 'Active' }, { id: 'I', text: 'Inactive' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>

                            <Column visible={false} dataType="datetime" caption='Creation Date' dataField='CREATIONDATETIME' />
                            <Column visible={false} dataType="string" caption='Created By' dataField='CREATIONUSERID' />
                            <Column visible={false} dataType="datetime" caption='Last Updated' dataField='LASTUPDATEDATETIME' />
                            <Column visible={false} dataType="string" caption='Last Updated By' dataField='LASTUPDATEUSERID' />

                            <Column visible={false} dataType="string" caption='OEM Code' dataField='OEMMANUFACTURERCODE' />
                            <Column visible={false} dataType="string" caption='Record #' dataField='RECORD' />
                            <Column visible={false} dataType="string" caption='ABC Code' dataField='ABCCODE' />

                            <Column visible={false} dataType="string" caption='Reason Code' dataField='STATUSREASONCODE' />
                            <Column visible={false} dataType="string" caption='Tax Status' dataField='TAXSTATUS' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes' }, { id: 'N', text: 'No' }, { id: 'A', text: 'Always Taxable' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Freight Class' dataField='FREIGHTCLASSCODE' />
                            <Column visible={false} dataType="string" caption='Count Cycle' dataField='PHYSICALCOUNTCODE' />
                            <Column visible={false} dataType="string" caption='Inventory Unit' dataField='INVENTORYUNITUOM' />
                            <Column visible={false} dataType="string" caption='Unit Net Wt' dataField='NETWEIGHTQUANTITY' />
                            <Column visible={false} dataType="string" caption='Unit Gross Wt' dataField='GROSSWEIGHTQUANTITY' />
                            <Column visible={false} dataType="string" caption='Receipt Pack & Size' dataField='RECEIPTPACKSIZE' />
                            <Column visible={false} dataType="string" caption='Box Code' dataField='BOXCODE' />
                            <Column visible={false} dataType="string" caption='Hazardous ' dataField='HAZARDOUSFLAG' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'No' }, { id: 'A', text: 'Yes' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Instructions' dataField='CAREINSTRUCTIONS' />
                            <Column visible={false} dataType="string" caption='Specifications' dataField='SPECIFICATIONCODE' />
                            <Column visible={false} dataType="string" caption='Alternate SKU' dataField='ITEMSUPCCODE' />
                            <Column visible={false} dataType="string" caption='IM Kit Flag' dataField='BOMEXPLOSIONFLAG' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'Not Used' }, { id: 'M', text: 'Update Kit Item Quantities, during Commit of IM Receipts only' }, { id: 'I', text: 'Access Kit Details From IM Transactions According To IM Profile' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='OM Kit Flag' dataField='OMKITFLAG' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'Not Used' }, { id: 'S', text: 'Auto-explode kit inputs in OM when entered' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>

                            <Column visible={false} dataType="datetime" caption='Introduced Dt' dataField='DATEINTRODUCED' />
                            <Column visible={false} dataType="datetime" caption='Available Dt' dataField='DATEAVAILABLE' />
                            <Column visible={false} dataType="datetime" caption='Expiration Dt' dataField='DATEEXPIRATION' />
                            <Column visible={false} dataType="string" caption='Item Source' dataField='ITEMSOURCEFLAG' >
                                <Lookup
                                    dataSource={[{ id: 'M', text: 'Manufactured' }, { id: 'P', text: 'Purchased' }, { id: 'O', text: 'Manufactured & Ordered' }, { id: 'R', text: 'Purchased & Ordered' }, { id: 'B', text: 'Brokered' }, { id: 'D', text: 'Drop-Ship' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Method' dataField='REORDERMETHODFLAG' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'Not Applicable' }, { id: 'M', text: 'Based on Min-Max Quantities' }, { id: 'P', text: 'Based on Min with Preset Order Quantity' }, { id: 'L', text: 'Lot Level' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>

                            <Column visible={false} dataType="string" caption='Minimum Qty' dataField='REORDERINVENTORYMINIMUMQTY' />
                            <Column visible={false} dataType="string" caption='Maximum Qty' dataField='REORDERINVENTORYMAXIMUMQTY' />
                            <Column visible={false} dataType="string" caption='Calculated Qty' dataField='REORDERQUANTITYEOQCALCULATED' />
                            <Column visible={false} dataType="string" caption='Entered Qty' dataField='REORDERQUANTITYENTERED' />
                            <Column visible={false} dataType="string" caption='Order Multiple' dataField='REORDERQUANTITYORDERMULTIPLE' />
                            <Column visible={false} dataType="string" caption='Safety Qty' dataField='REORDERSAFETYQUANTITY' />
                            <Column visible={false} dataType="string" caption='Cost Basis' dataField='COSTBASISMETHODFLAG' >
                                <Lookup
                                    dataSource={[{ id: 'S', text: 'Standard Cost' }, { id: 'A', text: 'Average Cost' }, { id: 'L', text: 'Last Cost' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Average Cost' dataField='AVERAGECOST' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Standard Cost' dataField='STANDARDCOST' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Core Price' dataField='COREPRICE' />
                            <Column visible={false} dataType="string" caption='Code 1' dataField='USERDEFINEDCODE_1' />
                            <Column visible={false} dataType="string" caption='Code 3' dataField='USERDEFINEDCODE_3' />
                            <Column visible={false} dataType="string" caption='Code 4' dataField='USERDEFINEDCODE_4' />
                            <Column visible={false} dataType="string" caption='Code 5' dataField='USERDEFINEDCODE_5' />
                            <Column visible={false} dataType="string" caption='Code 6' dataField='USERDEFINEDCODE_6' />
                            <Column visible={false} dataType="string" caption='Code 7' dataField='USERDEFINEDCODE_7' />
                            <Column visible={false} dataType="string" caption='Code 8' dataField='USERDEFINEDCODE_8' />
                            <Column visible={false} dataType="string" caption='Code 2' dataField='USERDEFINEDCODE_2' />
                            <Column visible={false} dataType="string" caption='Code 9' dataField='USERDEFINEDCODE_9' />
                            <Column visible={false} dataType="string" caption='Code 10' dataField='USERDEFINEDCODE_10' />
                            <Column visible={false} dataType="string" caption='Reference 1' dataField='USERDEFINEDREFERENCE_1' />
                            <Column visible={false} dataType="string" caption='Reference 2' dataField='USERDEFINEDREFERENCE_2' />
                            <Column visible={false} dataType="string" caption='Reference 3' dataField='USERDEFINEDREFERENCE_3' />
                            <Column visible={false} dataType="string" caption='Reference 4' dataField='USERDEFINEDREFERENCE_4' />
                            <Column visible={false} dataType="string" caption='Reference 5' dataField='USERDEFINEDREFERENCE_5' />
                            <Column visible={false} dataType="string" caption='Reference 6' dataField='USERDEFINEDREFERENCE_6' />
                            <Column visible={false} dataType="string" caption='Reference 7' dataField='USERDEFINEDREFERENCE_7' />
                            <Column visible={false} dataType="string" caption='Reference 8' dataField='USERDEFINEDREFERENCE_8' />
                            <Column visible={false} dataType="string" caption='Reference 9' dataField='USERDEFINEDREFERENCE_9' />
                            <Column visible={false} dataType="string" caption='Reference 10' dataField='USERDEFINEDREFERENCE_10' />
                            <Column visible={false} dataType="datetime" caption='Date 1' dataField='USERDEFINEDDATE_1' />
                            <Column visible={false} dataType="datetime" caption='Date 2' dataField='USERDEFINEDDATE_2' />
                            <Column visible={false} dataType="datetime" caption='Date 3' dataField='USERDEFINEDDATE_3' />
                            <Column visible={false} dataType="datetime" caption='Date 4' dataField='USERDEFINEDDATE_4' />
                            <Column visible={false} dataType="datetime" caption='Date 5' dataField='USERDEFINEDDATE_5' />
                            <Column visible={false} dataType="datetime" caption='Date 6' dataField='USERDEFINEDDATE_6' />
                            <Column visible={false} dataType="datetime" caption='Date 7' dataField='USERDEFINEDDATE_7' />
                            <Column visible={false} dataType="datetime" caption='Date 8' dataField='USERDEFINEDDATE_8' />
                            <Column visible={false} dataType="datetime" caption='Date 9' dataField='USERDEFINEDDATE_9' />
                            <Column visible={false} dataType="datetime" caption='Date 10' dataField='USERDEFINEDDATE_10' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 1' dataField='USERDEFINEDQUANTITY_1' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 2' dataField='USERDEFINEDQUANTITY_2' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 3' dataField='USERDEFINEDQUANTITY_3' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 4' dataField='USERDEFINEDQUANTITY_4' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 5' dataField='USERDEFINEDQUANTITY_5' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 6' dataField='USERDEFINEDQUANTITY_6' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 7' dataField='USERDEFINEDQUANTITY_7' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 8' dataField='USERDEFINEDQUANTITY_8' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 9' dataField='USERDEFINEDQUANTITY_9' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 10' dataField='USERDEFINEDQUANTITY_10' />
                            <Column visible={false} dataType="string" caption='Name' dataField='NAME' />
                            <Column visible={false} dataType="string" caption='Vendor Item ' dataField='VENDORITEMCODE' />
                            <Column visible={false} dataType="string" caption='Trade Disc' dataField='ARTRADEDISCOUNTFLAG' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes, Apply Customer Discount' }, { id: 'N', text: 'No' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='AR Terms Disc' dataField='ARTERMSDISCOUNTFLAG' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes, Apply Customer Terms Discount' }, { id: 'N', text: 'No' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Sales Multiple' dataField='SALEINCREMENTQUANTITY' />
                            <Column visible={false} dataType="string" caption='Min Sales Qty' dataField='MINIMUMSALESQUANTITY' />
                            <Column visible={false} dataType="string" caption='Class' dataField='LOCATIONCLASSFORWARDPICK' />
                            <Column visible={false} dataType="string" caption='Location Class Replenishment' dataField=' LOCATIONCLASSREPLENSHMENT' />
                            <Column visible={false} dataType="string" caption='Location Class Reserve' dataField='LOCATIONCLASSRESERVE' />
                            <Column visible={false} dataType="string" caption='Subclass' dataField='LOCATIONSUBCLASSFORWARDPICK' />
                            <Column visible={false} dataType="string" caption='Location Subclass Replenishment' dataField=' LOCATIONSUBCLASSREPLENSHMENT' />
                            <Column visible={false} dataType="string" caption='Location Subclass Reserve' dataField=' LOCATIONSUBCLASSRESERVE' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Maximum Units' dataField='LOCATIONMAXUNITSFORWARDPICK' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Minimum Units' dataField='LOCATIONMINUNITSFORWARDPICK' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Pending Rec' dataField='IN_ORDERED' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='In Receiving' dataField='IN_RECEIVING' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='In Shipping' dataField='OUT_SHIPPED' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='BO Receiving' dataField='IN_BACKORDER' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='BO Shipping' dataField='OUT_BACKORDER' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Unavailable' dataField='OUT_UNAVAILABLE' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Future Rec' dataField='IN_FUTURE' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Future Ship' dataField='OUT_FUTURE' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Available' dataField='AVAILABLE' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Net Available' dataField='NETAVAILABLE' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Last Cost' dataField='LASTCOST' />
                            <Column visible={false} dataType="string" caption='Inventory Source' dataField='INVENTORYQUANTITYSOURCE' >
                                <Lookup
                                    dataSource={[{ id: 'I', text: 'Item' }, { id: 'L', text: 'Lot' }, { id: 'S', text: 'Sublot' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Rate Source' dataField='RATESOURCE' >
                                <Lookup
                                    dataSource={[{ id: 'I', text: 'Item' }, { id: 'L', text: 'Lot' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Rate Selection' dataField='RATESELECTION' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'Show All Rate Schedules' }, { id: 'C', text: 'Filter By Customer' }, { id: 'L', text: 'Filter By Customer/Class' }, { id: 'S', text: 'Filter By Customer/Class/Sub Class' }, { id: 'U', text: 'Filter By Class' }, { id: 'V', text: 'Filter By Sub Class' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Prod Category' dataField='PRODUCTCATEGORYCODE' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Size - 1' dataField='SIZE_1' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Size - 2' dataField='SIZE_2' />
                            <Column visible={false} dataType="string" caption='Mgmt Source' dataField='MANAGEMENTSOURCE' >
                                <Lookup
                                    dataSource={[{ id: 'I', text: 'Item' }, { id: 'L', text: 'Lot' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Sublot Unique' dataField='SUBLOTUNIQUEFLAG' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'Not Applicable' }, { id: 'Y', text: 'All Sublots Created Will Be Assumed To Be Unique & Always Have a Quantity Of One' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Profile' dataField='ProfileCode' />
                            <Column visible={false} dataType="string" caption='Profile Description' dataField='ProfileDescription' />
                            <Column visible={false} dataType="string" caption='First Receipt' dataField='INTRANSACTIONNUMBER' />
                            <Column visible={false} dataType="datetime" caption='Last Receipt Dt' dataField='DATELASTRECEIPT' />
                            <Column visible={false} dataType="string" caption='Item' dataField='ITEMPAYGROUP' />
                            <Column visible={false} dataType="string" caption='Recurring Flag' dataField='RECURRINGSTORAGE' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes, Always Generate Recurring Storage Charges' }, { id: 'N', text: 'No, Never Generate Recurring Storage Charges' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Accessibility' dataField='WEBACCESSIBILITY' >
                                <Lookup
                                    dataSource={[{ id: 'A', text: 'Accessible to both salespeople and customers' }, { id: 'S', text: 'Accessible only to salespeople' }, { id: 'C', text: 'Accessible only to customers' }, { id: 'N', text: 'Not accessible' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='PM Kit Flag' dataField='PMKITFLAG' >
                                <Lookup
                                    dataSource={[{ id: 'A', text: 'Not Used' }, { id: 'B', text: 'Production Item' }, { id: 'C', text: 'Alternate Production Item' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>

                            <Column visible={false} dataType="string" caption='Source' dataField='WARRANTYFLAG_SHIPMENT' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'Not Applicable' }, { id: 'I', text: 'Use Item Expiration Date' }, { id: 'L', text: 'Use Lot Expiration Date' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Chk Max Days' dataField='CHECKMAXDAYS' >
                                <Lookup
                                    dataSource={[{ id: '1', text: 'No' }, { id: '2', text: 'Yes, check but allow override' }, { id: '3', text: 'Yes, check but never allow override' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Check Lot Exp' dataField='CHECKLOTEXPIRATION' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes' }, { id: 'N', text: 'No' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Price Code' dataField='PRICECODE' />
                            <Column visible={false} dataType="string" caption='Qty Auto Update' dataField='AUTOMATICALLYUPDATEQUANTITY' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'No, Not Applicable' }, { id: 'U', text: 'Yes, Update Units as Quantity' }, { id: 'W', text: 'Yes, Update Weight as Quantity' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Update UOM Wt' dataField='UPDATEUOMWEIGHT' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes, Update Average Weights Based on Serial #39' }, { id: 'N', text: 'No, Not Applicable' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Available' dataField='LOCATIONAVAILABLEDEFAULT' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes, Available' }, { id: 'N', text: 'No, Not Available' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Reason Code' dataField='LOCATIONREASONCODEDEFAULT' />
                            <Column visible={false} dataType="string" caption='Item Group' dataField='R_ITEMGROUP' />
                            <Column visible={false} dataType="string" caption='Item Sub Group' dataField='ITEMSUBGROUP' />
                            <Column visible={false} dataType="string" caption='Item Member' dataField='ITEMMEMBER' />
                            <Column visible={false} dataType="string" caption='Chk Rec Days' dataField='CHECKRECEIPTDAYS' >
                                <Lookup
                                    dataSource={[{ id: '1', text: 'No expiration days checking' }, { id: '2', text: 'Check days and allow to continue' }, { id: '3', text: 'Check days and do not allow to continue' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Chk Ship Days' dataField='CHECKSHIPMENTDAYS' >
                                <Lookup
                                    dataSource={[{ id: '1', text: 'No expiration days checking' }, { id: '2', text: 'Check days and allow to continue' }, { id: '3', text: 'Check days and do not allow to continue' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Mandated Fees' dataField='R_IMMANDATEDFEES' />
                            <Column visible={false} dataType="string" caption='Based on' dataField='EXPDATEBASEDON' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'None' }, { id: 'A', text: 'Receive/Ship date of Receipt' }, { id: 'B', text: 'Lot Code as Truncated JD of Receipt' }, { id: 'C', text: 'Lot Code as Modified JD of Receipt' }, { id: 'D', text: 'Lot Code as Julian Day of Receipt' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Add Days' dataField='ADDTOEXPDATE' />
                            <Column visible={false} dataType="string" caption='Code 11' dataField='USERDEFINEDCODE_11' />
                            <Column visible={false} dataType="string" caption='Code 12' dataField='USERDEFINEDCODE_12' />
                            <Column visible={false} dataType="string" caption='Code 13' dataField='USERDEFINEDCODE_13' />
                            <Column visible={false} dataType="string" caption='Code 14' dataField='USERDEFINEDCODE_14' />
                            <Column visible={false} dataType="string" caption='Code 15' dataField='USERDEFINEDCODE_15' />
                            <Column visible={false} dataType="string" caption='Code 16' dataField='USERDEFINEDCODE_16' />
                            <Column visible={false} dataType="string" caption='Code 17' dataField='USERDEFINEDCODE_17' />
                            <Column visible={false} dataType="string" caption='Code 18' dataField='USERDEFINEDCODE_18' />
                            <Column visible={false} dataType="string" caption='Code 19' dataField='USERDEFINEDCODE_19' />
                            <Column visible={false} dataType="string" caption='Code 20' dataField='USERDEFINEDCODE_20' />
                            <Column visible={false} dataType="string" caption='Reference 11' dataField='USERDEFINEDREFERENCE_11' />
                            <Column visible={false} dataType="string" caption='Reference 12' dataField='USERDEFINEDREFERENCE_12' />
                            <Column visible={false} dataType="string" caption='Reference 13' dataField='USERDEFINEDREFERENCE_13' />
                            <Column visible={false} dataType="string" caption='Reference 14' dataField='USERDEFINEDREFERENCE_14' />
                            <Column visible={false} dataType="string" caption='Reference 15' dataField='USERDEFINEDREFERENCE_15' />
                            <Column visible={false} dataType="string" caption='Reference 16' dataField='USERDEFINEDREFERENCE_16' />
                            <Column visible={false} dataType="string" caption='Reference 17' dataField='USERDEFINEDREFERENCE_17' />
                            <Column visible={false} dataType="string" caption='Reference 18' dataField='USERDEFINEDREFERENCE_18' />
                            <Column visible={false} dataType="string" caption='Reference 19' dataField='USERDEFINEDREFERENCE_19' />
                            <Column visible={false} dataType="string" caption='Reference 20' dataField='USERDEFINEDREFERENCE_20' />
                            <Column visible={false} dataType="datetime" caption='Date 11' dataField='USERDEFINEDDATE_11' />
                            <Column visible={false} dataType="datetime" caption='Date 12' dataField='USERDEFINEDDATE_12' />
                            <Column visible={false} dataType="datetime" caption='Date 13' dataField='USERDEFINEDDATE_13' />
                            <Column visible={false} dataType="datetime" caption='Date 14' dataField='USERDEFINEDDATE_14' />
                            <Column visible={false} dataType="datetime" caption='Date 15' dataField='USERDEFINEDDATE_15' />
                            <Column visible={false} dataType="datetime" caption='Date 16' dataField='USERDEFINEDDATE_16' />
                            <Column visible={false} dataType="datetime" caption='Date 17' dataField='USERDEFINEDDATE_17' />
                            <Column visible={false} dataType="datetime" caption='Date 18' dataField='USERDEFINEDDATE_18' />
                            <Column visible={false} dataType="datetime" caption='Date 19' dataField='USERDEFINEDDATE_19' />
                            <Column visible={false} dataType="datetime" caption='Date 20' dataField='USERDEFINEDDATE_20' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 11' dataField='USERDEFINEDQUANTITY_11' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 12' dataField='USERDEFINEDQUANTITY_12' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 13' dataField='USERDEFINEDQUANTITY_13' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 14' dataField='USERDEFINEDQUANTITY_14' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 15' dataField='USERDEFINEDQUANTITY_15' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 16' dataField='USERDEFINEDQUANTITY_16' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 17' dataField='USERDEFINEDQUANTITY_17' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 18' dataField='USERDEFINEDQUANTITY_18' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 19' dataField='USERDEFINEDQUANTITY_19' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 20' dataField='USERDEFINEDQUANTITY_20' />
                            <Column visible={false} dataType="string" caption='Consignee Adj Days' dataField='WMCONSIGNEEEXPDAYS' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Adjust Expiration Days by Consignee' }, { id: 'N', text: 'Do Not Adjust Expiration Days by Consignee' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Item Ref 1' dataField='REFERENCE_1' />
                            <Column visible={false} dataType="string" caption='Item Ref 2' dataField='REFERENCE_2' />
                            <Column visible={false} dataType="string" caption='Item Ref 3' dataField='REFERENCE_3' />
                            <Column visible={false} dataType="string" caption='Item Ref 4' dataField='REFERENCE_4' />
                            <Column visible={false} dataType="string" caption='Item Ref 5' dataField='REFERENCE_5' />
                            <Column visible={false} dataType="string" caption='Oversell %' dataField='OVERSELLPERCENTAGE' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Sale Max Qty' dataField='SALEMAXQUANTITY' />
                            <Column visible={false} dataType="string" caption='Container Code' dataField='CONTAINERCODE' />
                            <Column visible={false} dataType="string" caption='Description' dataField='DESCRIPTION' />

                            <GridToolbar>
                                <GridToolbarItem location="before">
                                    <Button
                                        disabled={isEditButtonDisabled}
                                        onClick={handelEditClick}
                                        type="default"
                                        text="Edit"
                                    ></Button>
                                </GridToolbarItem>
                                <GridToolbarItem location="before">
                                    <div>
                                        <Link to="/wm/codes/add-item">
                                            <Button
                                                type="default"
                                                className="gridTopButton"
                                                text="Create"
                                            ></Button>
                                        </Link>
                                    </div>
                                </GridToolbarItem>
                                 <GridToolbarItem location="after">
                                 <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(List);